import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy,
  Self,
  ChangeDetectorRef
} from '@angular/core';
import { fromEvent } from 'rxjs';
import { filter, debounceTime, distinctUntilChanged, takeUntil, tap } from 'rxjs/operators';
import { NgOnDestroyService } from '../services/ng-on-destroy.service';
import { NewFilesListService } from '../files-list/files-list.service';

@Component({
  selector: 'file-search',
  templateUrl: './file-search.component.html',
  styleUrls: ['./file-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [NgOnDestroyService]
})
export class FileSearchComponent implements OnInit {
  public searchTerm: string;

  @ViewChild('inputSearch', {static: true}) input: ElementRef;
  @ViewChild('searchButton', {static: true}) searchBtn: ElementRef;
  @ViewChild('refreshButton', {static: true}) refreshBtn: ElementRef;

  @Output() refresh: EventEmitter<any> = new EventEmitter<any>();
  @Output() search: EventEmitter<string> = new EventEmitter<string>();

  private oldSearchData: string;

  constructor(
    @Self() private ngOnDestroy$: NgOnDestroyService,
    protected cdRef: ChangeDetectorRef,
    private flService: NewFilesListService
  ) {
    this.flService.isFilesOnlyMode$
      .pipe(takeUntil(this.ngOnDestroy$))
      .subscribe(() => {
        this.searchTerm = '';
        this.oldSearchData = '';
        this.cdRef.markForCheck();
      });
  }

  ngOnInit() {
    fromEvent(this.input.nativeElement, 'keyup')
      .pipe(
        filter((e: KeyboardEvent) => e.code === 'Enter'),
        debounceTime(300),
        distinctUntilChanged(),
        takeUntil(this.ngOnDestroy$)
      ).subscribe(() => this.search.emit(this.searchTerm));

    fromEvent(this.searchBtn.nativeElement, 'click')
      .pipe(
        debounceTime(300),
        filter(() => this.searchTerm !== this.oldSearchData),
        tap(() => this.oldSearchData = this.searchTerm),
        takeUntil(this.ngOnDestroy$)
      ).subscribe(() => this.search.emit(this.searchTerm));

    fromEvent(this.refreshBtn.nativeElement, 'click')
      .pipe(
        debounceTime(300),
        takeUntil(this.ngOnDestroy$),
        tap(() => this.oldSearchData = this.searchTerm),
      ).subscribe(() => this.search.emit(this.searchTerm));
  }
}
